import React from 'react'
import { FeatureFlags } from '@mobi/settings/featureFlags'
import { scriptLoader } from '@mobi/utils/scriptLoader'
import { useFeature } from '@core/Utils/hooks'

// The provided script snippet has been moved into a component for better handling within the app
// The script components have been pulled out of the snippet and we handle the defered loading/running of the script
// Below is the snippet provided by Qualtrics to integrate with Mobi
//
// <!--BEGIN QUALTRICS WEBSITE FEEDBACK SNIPPET-->
// <script type='text/javascript'>
// (function(){var g=function(g){
// this.go=function(){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)};
// this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
// try{(new g("https://zn1puef1eizhbf7ep-rwwa.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_1PUEf1eizHBF7eP")).start()}catch(i){}})();
// </script><div id='ZN_1PUEf1eizHBF7eP'><!--DO NOT REMOVE-CONTENTS PLACED HERE--></div>
// <!--END WEBSITE FEEDBACK SNIPPET-->
//

const QUALTRICS_DIV_ID = 'ZN_1PUEf1eizHBF7eP'
const QUALTRICS_SCRIPT_URL =
  'https://zn1puef1eizhbf7ep-rwwa.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_1PUEf1eizHBF7eP'

export const QualtricsBootstrap: React.FC = () => {
  const scriptElementRef = React.useRef<HTMLScriptElement>()
  const isQualtricsEnabled = useFeature(FeatureFlags.QUALTRICS_INSIGHTS.key)

  React.useEffect(() => {
    const handleLoadScript = async () => {
      if (!scriptElementRef.current) {
        scriptElementRef.current = await scriptLoader(
          QUALTRICS_SCRIPT_URL,
          {
            type: 'text/javascript',
          },
          true
        )
      }
    }

    if (isQualtricsEnabled) handleLoadScript()
    else {
      scriptElementRef.current?.remove()
      scriptElementRef.current = undefined
    }
  }, [isQualtricsEnabled])

  return isQualtricsEnabled ? <div id={QUALTRICS_DIV_ID} /> : null
}
